module.exports = __webpack_public_path__ + "img/data_bg_b.64cc55bd.png";